module.exports = __webpack_public_path__ + "static/media/ge.a8493dc5.svg";